<template>
    <div>
        <navigation-bar Close Bell :name="'熱銷商品'"/>
        <div class="main">

            <item-grid class="two-gird" :key="productUpdateKey">
                <commodity-item :list="productList" :routerName="'Product'"/>
            </item-grid>

<!--            <infinite-loading @infinite="setupDataScroll" spinner="waveDots">-->
<!--                <div slot="no-more">沒有更多資料</div>-->
<!--                <span slot="no-results"/>-->
<!--            </infinite-loading>-->

            <loading
                    :active.sync=isLoading
                    :can-cancel="false"
                    :is-full-page="true"
            />
        </div>
    </div>

</template>

<script>
    import ItemGrid from '@/components/category/ItemGrid.vue';
    import CommodityItem from '@/views/store/components/CommodityItem.vue';

export default {
    name: 'ProductList',
    components: {
        ItemGrid,
        CommodityItem,
    },
    data() {
        return {
            //假資料可刪
            // commodityList: [{ "commodityId": 1, "commodityImage": "https://file-test.oinapp.com/oin/commodityImage/1656316526880331.jpeg", "commodityName": "肉品", "commodityPrice": 100 }, { "commodityId": 21, "commodityImage": "https://file-test.oinapp.com/oin/commodityImage/1664347161189131", "commodityName": "恐龍肉", "commodityPrice": 299 }, { "commodityId": 22, "commodityImage": "https://file-test.oinapp.com/oin/commodityImage/1664351242416773", "commodityName": "火腿", "commodityPrice": 120 }, { "commodityId": 23, "commodityImage": "https://file-test.oinapp.com/oin/commodityImage/1664352002719877", "commodityName": "鬆餅", "commodityPrice": 0 }, { "commodityId": 24, "commodityImage": "https://file-test.oinapp.com/oin/commodityImage/1664352043062139", "commodityName": "包子肉", "commodityPrice": 122 }, { "commodityId": 25, "commodityImage": "https://file-test.oinapp.com/oin/commodityImage/1664352068915481", "commodityName": "披薩", "commodityPrice": 0 }, { "commodityId": 26, "commodityImage": "https://file-test.oinapp.com/oin/commodityImage/1664352226016278", "commodityName": "超級金華火腿肉肉肉庫肉歐", "commodityPrice": 10000 }, { "commodityId": 27, "commodityImage": "https://file-test.oinapp.com/oin/commodityImage/1664352226016793", "commodityName": "麵套餐", "commodityPrice": 199 }, { "commodityId": 28, "commodityImage": "https://file-test.oinapp.com/oin/commodityImage/1664352226019093", "commodityName": "貓喔", "commodityPrice": 0 }, { "commodityId": 29, "commodityImage": "https://file-test.oinapp.com/oin/commodityImage/1664352226019395", "commodityName": "龍肉", "commodityPrice": 122 }],
            dataToken: this.$route.query.dataToken !== undefined ? this.$route.query.dataToken : "",        //url 傳來的加密參數
            productList: [],
            shopAreaId: 0,
            productUpdateKey: 0,
            isLoading: false,
        }
    },
    created() {
    },
    mounted() {
        try {
            let cryptoDataToken = this.$crypto.uriComponentToObject(this.dataToken);
            let dataObject = JSON.parse(cryptoDataToken);

            if (this.$public.notNull(dataObject?.productList)) {
                this.productList = this.parseList(dataObject.productList);
            }

            if (this.$public.notNull(dataObject?.shopAreaId)) {
                this.shopAreaId = dataObject.shopAreaId;

                //把shopAreaId屬性加到 productList的元素中
                this.productList.forEach( item => {
                    item.shopAreaId = this.shopAreaId;
                })
            }

        } catch (e) {
            console.log(`productList mounted error: ${e}`);
        }
    },
    methods:{
        /** 轉換商品陣列 */
        parseList(itemList) {
            let self = this;
            let result = [];
            if (this.$public.notNull(itemList)) {
                itemList.forEach(function (item, index) {
                    //
                    // if (item.status === 1) {
                        let newItem = {
                            commodityId: item.id,
                            commodityName: item.name,
                            commodityImage: item.path,
                            commodityPrice: item.price,
                            shopAreaId: 0,
                        };
                        result.tmz_load_push(newItem);
                    // }
                });
                self.productUpdateKey++;
            }

            return result;
        },

        setupDataScroll() {

        },
    },
}
</script>
<style lang="less" scoped>
    .content{
        padding-bottom: 100px;
    }
    .isWeb .main .el-header{
        @media(min-width: 1024px){
            display: block;
        }
    }
    .main{
        @media(max-width: 1023px){
            margin-top: 20px;
        }
    }
</style>